import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilePlus2 } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { PageHeader, Section, StatusBadge, Empty, RowLink } from "../components/common";
import { fmtDate, money } from "../lib/helpers";

const FILTERS = [["", "All", "Todos"], ["draft", "Draft", "Borrador"], ["sent", "Sent", "Enviados"], ["approved", "Approved", "Aprobados"], ["lost", "Lost", "Perdidos"]];

export default function Estimates() {
  const { t, lang } = useLang();
  const nav = useNavigate();
  const { can } = useAuth();
  const [status, setStatus] = useState("");
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/estimates", { params: { status } }).then((r) => setList(r.data)); }, [status]);
  return (
    <>
      <PageHeader title={t("Estimates", "Presupuestos")} actions={can("view_prices") && <button className="btn-primary" onClick={() => nav("/estimates/new")} data-testid="estimates-new-btn"><FilePlus2 className="w-5 h-5" /> {t("New Estimate", "Nuevo presupuesto")}</button>} />
      <div className="flex gap-2 overflow-x-auto mb-4">
        {FILTERS.map(([k, en, es]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`estimates-filter-${k || "all"}`} className={`btn-sm btn shrink-0 ${status === k ? "bg-slate-900 text-white" : "bg-white border border-slate-300"}`}>{lang === "es" ? es : en}</button>
        ))}
      </div>
      <Section testid="estimates-list">
        {list && !list.length && <Empty text={t("No estimates", "Sin presupuestos")} />}
        {list?.map((e) => (
          <RowLink key={e.id} to={`/estimates/${e.id}`} testid={`estimate-row-${e.id}`}>
            <span className="mono text-sm font-semibold w-14">#{e.number}</span>
            <div className="flex-1 min-w-0"><div className="font-semibold truncate">{e.customer_name}</div><div className="text-xs text-slate-500 truncate">{e.service} · {fmtDate(e.date, lang)}</div></div>
            {e.price != null && <span className="mono text-sm hidden sm:block">{money(e.price)}</span>}
            <StatusBadge status={e.status} />
          </RowLink>
        ))}
      </Section>
    </>
  );
}
